/* ZSportsTech — tile-quickadd.js
   Quick-add control on accessory catalogue tiles (.product-tile__qa). The tile
   itself is an <a class="product-tile"> that navigates to the PDP, so the
   control MUST stopPropagation + preventDefault before doing anything else, or
   the click falls through to the anchor and the page navigates.

   Single-variant accessories (e.g. bat-wax) add straight to cart via
   window.SCCart.add(id, 1). Multi-variant accessories (e.g. bat-grips, 24
   variants) open window.SCVariantPicker so the shopper can choose first.
   ─────────────────────────────────────────────────────────────────────── */
(function () {
  'use strict';

  function findTile(el) {
    while (el && el !== document) {
      if (el.classList && el.classList.contains('product-tile')) return el;
      el = el.parentNode;
    }
    return null;
  }

  function setState(control, label, disabled) {
    control.textContent = label;
    if (disabled) control.setAttribute('aria-disabled', 'true');
    else control.removeAttribute('aria-disabled');
  }

  function handle(control) {
    if (control.getAttribute('aria-disabled') === 'true') return;

    var tile = findTile(control);
    if (!tile) return;

    if (!window.SCCart) return;

    var count = parseInt(tile.getAttribute('data-qa-count'), 10) || 0;
    var id = tile.getAttribute('data-qa-id');
    var handleAttr = tile.getAttribute('data-qa-handle');

    setState(control, '+ Add', true);

    function done(ok) {
      if (ok) {
        setState(control, 'Added ✓', true);
        window.setTimeout(function () { setState(control, '+ Add', false); }, 1200);
      } else {
        setState(control, '+ Add', false);
      }
    }

    if (count === 1 && id) {
      window.SCCart.add(Number(id), 1).then(function () { done(true); }).catch(function () { done(false); });
      return;
    }

    if (!window.SCVariantPicker) {
      console.error('[tile-quickadd] SCVariantPicker not loaded; cannot open variant picker for', handleAttr);
      setState(control, '+ Add', false);
      return;
    }

    window.SCVariantPicker.open(handleAttr, function (variantId) {
      if (variantId) {
        window.SCCart.add(Number(variantId), 1).then(function () { done(true); }).catch(function () { done(false); });
      } else {
        setState(control, '+ Add', false);
      }
    });
  }

  document.addEventListener('click', function (e) {
    var control = e.target.closest ? e.target.closest('.product-tile__qa') : null;
    if (!control) return;
    e.stopPropagation();
    e.preventDefault();
    handle(control);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ' && e.key !== 'Spacebar') return;
    var control = e.target.closest ? e.target.closest('.product-tile__qa') : null;
    if (!control) return;
    e.stopPropagation();
    e.preventDefault();
    handle(control);
  });
}());
